import adminApi from './adminAPI';

export const ipsBloqueadosAPI = {
  async listar() {
    const { data } = await adminApi.get('/ips-bloqueados');
    return data.ips;
  },

  async listarLivres() {
    const { data } = await adminApi.get('/ips-bloqueados/livres');
    return data.ips;
  },

  async bloquear(ip, motivo) {
    const { data } = await adminApi.post('/ips-bloqueados', { ip, motivo });
    return data;
  },

  async desbloquear(id) {
    await adminApi.delete(`/ips-bloqueados/${id}`);
  },

  async listarEventos(tipo) {
    const { data } = await adminApi.get('/ips-bloqueados/eventos', { params: tipo ? { tipo } : {} });
    return data;
  }
};

export const logsAuditoriaAPI = {
  async listar(limite = 500) {
    const { data } = await adminApi.get(`/logs?limite=${limite}`);
    return data.logs;
  }
};
